import React, { useEffect, useRef, useState } from 'react';

import OnboardCell from '../../components/onboardCell';
import StakingCell from '../../components/stakingCell';
import ProofTable from '../../components/proofTable';
import NewsletterCell from '../../components/newsletterCell';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { isStaked } from '../../httpcalls/contractThunk';
import { resetStaking } from '../../store/schemas/stakingSlice';
import { ClientOnly } from '../../../library/client/serverCallHandler';
import { MetaTagHandler } from '../../../library/client/serverCallHandler';
import Footer from '../../components/footer';

import StakingDashboard from './stakeholderDashboard';
import AccordionComp from '../../components/global/accordion';
import S_Onboarding from './s_onboarding';
import useEffectClient from '../../helpers/networkHook';


const Stakeholder = () => {
  const dispatch = useDispatch()
  const isStakeholder = useSelector(state => state.mainapp.stakingSlice.isStakeholder);
  const accountId = useSelector((state) => state.auth.metamask.accountId)

  useEffect(() => {
    window.scrollTo(0, 0);

  }, []);


  useEffectClient(() => {
    if (accountId == null) {
      dispatch(resetStaking())
    }
    else {
      dispatch(isStaked())
    }
  }, [accountId])
  return (
    <>



      <MetaTagHandler>
        {() => (
          <>
            <title>Stakeholders | PLURI</title>
            <meta name="description" content="Being a Pluri stakeholder provides a profitable investment opportunity with assured regular rewards, stability and transparency, and a strong emphasis on data integrity and security." />
            <meta property="og:title" content="PLURI | Stakeholders" />
            <meta property="og:description" content="Being a Pluri stakeholder provides a profitable investment opportunity with assured regular rewards, stability and transparency, and a strong emphasis on data integrity and security." />
            <meta property="og:image" content={`https://${process.env.REACT_APP_ORIGIN}/assets/pluriBanner.png`} />
            <meta property="og:url" content={`https://${process.env.REACT_APP_ORIGIN}/stakeholders`} />
            <meta property="og:site_name" content="PLURI" />
            <meta property="og:type" content="website" />
            <meta property="og:locale" content="en_US" />

          </>
        )}
      </MetaTagHandler>



      {
        isStakeholder ?
          <div className='vivify fadeIn duration-300'>
            <ClientOnly fallback={<S_Onboarding />}>
              {() => (

                <StakingDashboard />
              )}
            </ClientOnly>
          </div> : <div className='vivify fadeIn duration-300'>

            <S_Onboarding />

          </div>
      }





      <Footer />




    </>
  );
};

export default Stakeholder;
